import React from 'react';
import BootcampTablePaginationFooter from './BootcampTablePaginationFooter';

const BootcampPaginatedTableCard = ({
  title,
  countLabel,
  searchPlaceholder,
  searchValue,
  onSearchChange,
  page,
  totalPages,
  onPageChange,
  isEmpty,
  cardClassName = '',
  exportId,
  children,
}) => {
  return (
    <section
      id={exportId}
      className={`bootcamp-card bootcamp-table-card bootcamp-paired-card bootcamp-paginated-card ${cardClassName}`.trim()}
    >
      <div className="bootcamp-card-header-actions">
        <h3>{title}</h3>
        {countLabel ? <span className="bootcamp-card-count">{countLabel}</span> : null}
      </div>

      <label className="bootcamp-table-search-wrap">
        <span className="bootcamp-sr-only">{searchPlaceholder}</span>
        <input
          type="search"
          className="bootcamp-table-search"
          placeholder={searchPlaceholder}
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </label>

      <div className="bootcamp-card-body bootcamp-table-body-fixed">
        {isEmpty ? (
          <div className="bootcamp-table-empty">No matching records found</div>
        ) : (
          children
        )}
      </div>

      <BootcampTablePaginationFooter page={page} totalPages={totalPages} onPageChange={onPageChange} />
    </section>
  );
};

export default BootcampPaginatedTableCard;
